import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { accountInitialize } from "store/accountActions";
import { staticData } from "managers/staticDataManager";

const { default: Dropdown } = require("react-multilevel-dropdown");

const langToSegment = (code) => (code || "").split("-")[0].toLowerCase();

const LaguageBar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { languages } = useSelector((state) => state.staticData);
  const account = useSelector((state) => state.account);

  const changeLanguageHandler = (code) => {
    const language = languages.find((lang) => lang.code === code);
    if (!language) return;

    if (account?.language?.code !== language.code) {
      dispatch(accountInitialize({ language }));

      const newSeg = langToSegment(language.code);

      history.push(`/${newSeg}${location.search || ""}${location.hash || ""}`);
    }
  };

  return (
    <Dropdown
      key={location.pathname + location.search + location.hash}
      className="header-panel__link font-weight-bold dropdown-navlink"
      title={staticData.loadTerms(useSelector, `VW_COMMON_LANGUAGE`)}
      wrapperClassName="ml-auto lang-dropdown"
    >
      {languages
        .filter((l) => l.isUsedFromPublishingDocuments)
        .map((lang) => (
          <Dropdown.Item
            key={`dropdown-item-${lang.code}`}
            onClick={() => changeLanguageHandler(lang.code)}
            className="dropdown-brand-color"
          >
            {lang.description}
          </Dropdown.Item>
        ))}
    </Dropdown>
  );
};

export default LaguageBar;
